import { useEffect, useMemo, useState } from 'react'

export const useShowDebounce = () => {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  const debouncedHandleResize = useMemo(
    () =>
      debounce(
        () =>
          setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
          }),
        250
      ),
    []
  )

  useEffect(() => {
    window.addEventListener('resize', debouncedHandleResize)
    return () => window.removeEventListener('resize', debouncedHandleResize)
  }, [debouncedHandleResize])

  return dimensions
}

function debounce(this: unknown, fn: () => void, ms: number) {
  let timer: ReturnType<typeof setTimeout>
  return (...args: []) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn.apply(this, args), ms)
  }
}
